import Splide from "@splidejs/splide";

///
// Overview map
///

const overviewMap = document.querySelectorAll('.splide-overview-map');

function focusOverviewMap(
  mapElement,
  translate = ['0','0'],
  scale = 1,
  backgroundFill = 'white')
{
  mapElement.style.setProperty('--transform-translate-x', translate[0]+'%');
  mapElement.style.setProperty('--transform-translate-y', translate[1]+'%');
  mapElement.style.setProperty('--transform-scale', scale);
  mapElement.style.setProperty('--background-fill', backgroundFill);
}

if (overviewMap.length) {
  for (let i = 0; i < overviewMap.length; i++) {

    const mapSvg = document.querySelector('.ubbm-overview-map__overview__svg');

    const menuButtons = document.querySelectorAll('[data-map-translate]');

    console.log({mapSvg, menuButtons});

    if (mapSvg) {
      menuButtons.forEach((button) => {
        const translateValue = button.dataset.mapTranslate.split(',');
        button.addEventListener('click', () => {
          if (button.classList.contains('collapsed')) {
            focusOverviewMap(mapSvg, ['0','0'], 1, 'white');
          } else {
            focusOverviewMap(mapSvg, translateValue, 2.5, 'transparent');
          }
        });
      });
    }

    const breakpoint = 1200;

    const overviewMapMenu = new Splide('.splide-overview-map', {
      pagination: false,
      mediaQuery: 'min',
      breakpoints: {
        0 : {
          perPage: 1,
          releaseWheel: false,
          loop: true,
          pagination: true,
        },
        [breakpoint] : {
          direction: 'ttb',
          height: '510px',
          perPage: 7,
          wheel: true,
          releaseWheel: true,
          loop: false,
          pagination: false,
        },
        1400 : {
          direction: 'ttb',
          height: '590px',
          perPage: 8,
          wheel: true,
          releaseWheel: true,
          loop: false,
          pagination: false,
        }
      }
    });

    overviewMapMenu.mount();

    if (window.innerWidth < breakpoint) {
      const translateValue = menuButtons[0].dataset.mapTranslate.split(',');
      focusOverviewMap(mapSvg, translateValue, 2.5, 'transparent');
    }
    overviewMapMenu.on('moved', function () {
      if (window.innerWidth < breakpoint) {
        const translateValue = menuButtons[overviewMapMenu.index * 2].dataset.mapTranslate.split(',');
        // index * 2 because there are two buttons for every slide, 1 for the mobile menu and 1 for the desktop menu
        focusOverviewMap(mapSvg, translateValue, 2.5, 'transparent');
      }
    });
  }
}
